import Danger from "@/images/Danger";
import Center from "@/tpo/Center";
import Stack from "@/tpo/Stack";

import Box from "./Box";
import { ExternalTextLink } from "./Links";
import PartnerDashboardBox from "./boxes/PartnerDashboardBox";

export function AccountOnHold({ children, withGreyOuterBox = true, maxWidth, mb }) {
  const content = (
    <Stack bg="white" borderRadius={20} px={40} pt={60} pb={80} maxWidth={maxWidth} mb={mb}>
      <Center gap={[10, 10, 20]}>
        <Danger size={[30, 40, 40]} />
        <Box as="h2" fontFamily="gilroyBold" fontSize={[24, 24, 36]}>
          Account on hold
        </Box>
      </Center>
      {children}
    </Stack>
  );

  if (withGreyOuterBox) {
    return (
      <PartnerDashboardBox bg="midGrey" borderRadius={20} data-component-name="AccountOnHold">
        {content}
      </PartnerDashboardBox>
    );
  }

  return content;
}

export function AccountOnHoldCheckoutMessage({ withGreyOuterBox = true, maxWidth, mb }) {
  return (
    <AccountOnHold withGreyOuterBox={withGreyOuterBox} maxWidth={maxWidth} mb={mb}>
      <Box textAlign="center" mx="auto" fontSize={[14, 14, 16]}>
        Your account is currently paused due to an overdue invoice, please contact{" "}
        <ExternalTextLink href="mailto:info@regeneruslabs.com">
          info@regeneruslabs.com
        </ExternalTextLink>{" "}
        to proceed with checkout
      </Box>
    </AccountOnHold>
  );
}
